import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "mb-5 border-b border-black pb-5" };
const _hoisted_2 = {
    key: 0,
    class: "mb-5 text-lg"
};
const _hoisted_3 = {
    key: 1,
    class: "lg:col-span-2",
    "data-policies-navigation": ""
};
const _hoisted_4 = { class: "flex flex-wrap gap-x-2 text-xs" };
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TabbedMenu',
    props: {
        title: {},
        menuItems: {}
    },
    setup(__props) {
        const getTitle = (title, overrideTitle) => {
            return overrideTitle !== '' ? overrideTitle : title;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.title)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(__props.title), 1))
                    : _createCommentVNode("", true),
                (__props.menuItems)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
                        _createElementVNode("ul", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (menuItem, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    class: "navItem flex items-center gap-2"
                                }, [
                                    _createVNode(ButtonWithArrow, {
                                        class: _normalizeClass({ '!font-jp': menuItem?.useJpFont }),
                                        text: getTitle(menuItem?.page.title, menuItem.title),
                                        url: menuItem?.page.url
                                    }, null, 8, ["class", "text", "url"])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
